import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Container } from '@comparethemarketau/manor-grid';

import { FooterDisclaimer } from './common/footer_disclaimer';
import { SecurityLogo } from './common/security_logo';
import { FooterCopyright } from './common/footer_copyright';

const useStyles = createUseStyles((theme) => ({
    container: {
        backgroundColor: theme.colors.white,
        fontSize: theme.fontSize.sm
    },
    topSection: {
        display: 'flex',
        marginBottom: theme.spacing[28]
    },
    securityLogo: {
        display: 'flex',
        justifyContent: 'flex-end',
        minWidth: '14.3rem'
    },
    copyright: {
        alignSelf: 'center'
    }
}));

const FooterManorSmToLg = ({ leftSpacing, rightSpacing }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classNames(classes.container)}>
            <Container padding={['32', leftSpacing, '12', rightSpacing]}>
                <div className={classes.topSection}>
                    <FooterDisclaimer className={classes.disclaimer} />
                    <SecurityLogo className={classes.securityLogo} />
                </div>
                <FooterCopyright className={classes.copyright}  />
            </Container>
        </div>
    );
};

FooterManorSmToLg.propTypes = {
    leftSpacing: PropTypes.string,
    rightSpacing: PropTypes.string
};

export { FooterManorSmToLg };
